<template>
  <div id="app">
    <el-container>
      <el-header height="40px" class="header">
        <router-link to="/">Главная</router-link> |
        <router-link to="/about">Про нас</router-link> |
        <template v-if="logged && isAdmin">
          <router-link to="/admin/createGame">Создать игру</router-link> |
          <router-link to="/admin">Админ зона</router-link> |
          <router-link to="/admin/checkAnswers">Проверка ответов</router-link> |
          <el-button size="small" type="text" @click="logout">Выйти</el-button>
        </template>
        <template v-else-if="logged">
          <router-link to="/Gamelist">Игры</router-link> |
          <router-link to="/profile">Профиль</router-link> |
          <el-button size="small" type="text" @click="logout">Выйти</el-button>
        </template>
        <template v-else>
          <router-link to="/login">Login</router-link>
        </template>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
      <el-footer height="20px" class="footer">
        <div class="centered">Mozgolom</div>
      </el-footer>
    </el-container>    
  </div>
</template>

<script>

export default {
  name: 'app',
  computed: {
    logged() {
      return this.$store.getters.logged;
    },
    isAdmin() {
      return this.$route.path?.toLowerCase().startsWith('/admin');
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
        .then(() => this.$router.push('/login'))
        .catch(({message}) => {
          console.log('caught error', message);
          this.$message({type: 'error', message})
        });
    }
  },
  watch: {
    logged: {
      handler(isLogged) {
        if(isLogged) {
          this.$store.dispatch('init');
        }
      },
      immediate: true
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
h1 {
  text-align: center;
}
.centered {
  text-align: center;
}
.leftaligned {
  text-align: left;
}
.el-input.error .el-input__inner {
  border-color: red;
}
.el-row {
  margin-bottom: 12px;
}
</style>
<style scoped>
  .header {
    border-bottom: 1px solid #ccc;
    padding: 5px 10px;
  }
  .main {
    min-height: calc(100vh - 50px - 20px)
  }
  .footer {
    border-top: 1px solid #ccc;
    padding-top: 5px;
  }
</style>